var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathArray20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4374 16.5625C3.02073 14.1146 2.71865 8.96876 4.84365 7.96876C7.4999 6.71876 11.4061 12.8125 14.6874 12.0313C17.3124 11.4063 17.1353 6.66667 16.7186 4.375",
    stroke: "#00C2FF",
    strokeWidth: 1.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.24805,
    y: 14.376,
    width: 4.37601,
    height: 4.37601,
    fill: "#222627"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0012,
    y: 1.87292,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.43701,
    y: 8.43689,
    width: 3.12601,
    height: 3.12601,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathArray20);
export default __webpack_public_path__ + "static/media/path-array_20.07f4afae8358ce1fbef2ddb350c4e878.svg";
export { ForwardRef as ReactComponent };